import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import PC from '@/components/PC'
import Mobile from '@/components/Mobile'

Vue.use(Router)
const Home = r => require.ensure([], () => r(require('@/components/home')), 'Home')
const IndexHome = r => require.ensure([], () => r(require('@/components/content/index1')), 'IndexHome')
const AboutUs = r => require.ensure([], () => r(require('@/components/content/index2')), 'AboutUs')
const PressCenter = r => require.ensure([], () => r(require('@/components/content/index3')), 'PressCenter')
const JoinInvestment = r => require.ensure([], () => r(require('@/components/content/index4')), 'JoinInvestment')
const Recruitment = r => require.ensure([], () => r(require('@/components/content/index5')), 'Recruitment')
const detail = r => require.ensure([], () => r(require('@/components/content/detail')), 'detail')

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index/home'
    },
    {
      path: '/index/',
      name: 'home',
      component: Home,
      children: [
        {
          path: 'home',
          name: '首页',
          component: IndexHome
        },
        {
          path: 'about',
          name: '关于我们',
          component: AboutUs
        },
        {
          path: 'pressCenter',
          name: '新闻中心',
          component: PressCenter
        },
        {
          path: 'detail',
          name: '新闻详情',
          component: detail
        },
        {
          path: 'joinInvestment',
          name: '招商加盟',
          component: JoinInvestment
        },
        {
          path: 'Recruitment',
          name: '招贤纳士',
          component: Recruitment
        }
      ]
    },
    /*{
      path: '/index',
      name: 'Index',
      component: Index,
      children: [
        {
          path: '/pc',
          name: 'PC',
          component: PC
        },
        {
          path: '/mobile',
          name: 'Mobile',
          component: Mobile
        }
      ]
    }*/
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js